import { useEffect, useState } from "react";

// Shared mobile breakpoint for the newLandingV2 pages — the point where the
// hero nav, and the filters/list/map and profile side-columns, stop having
// room to sit next to their neighbor.
export const MOBILE_MEDIA_QUERY = "(max-width: 760px)";

export function isMobileNow() {
  return typeof window !== "undefined" && window.matchMedia(MOBILE_MEDIA_QUERY).matches;
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(isMobileNow);
  useEffect(() => {
    const mql = window.matchMedia(MOBILE_MEDIA_QUERY);
    const onChange = (e) => setIsMobile(e.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);
  return isMobile;
}
